import {
  EvidencePackageDistributorConfig,
  EvidencePackagerConfig,
  EvidencePackageSchedulerConfig,
  EvidencePackageSchedulerConfigItem,
} from './evidenceConfigs';

export enum ViolationProcessor {
  DUNCAN = 'DUNCAN',
  CONDUENT = 'CONDUENT', // Trellint
  T2 = 'T2',
}

export interface AuthorityConfig {
  enable_evidence_pipeline: boolean;
  evidence_package_distributor_config: EvidencePackageDistributorConfig;
  evidence_package_scheduler_config: EvidencePackageSchedulerConfig;
  evidence_packager_config: EvidencePackagerConfig;
  external_review_enabled: boolean;
  features_config: {
    kyndryl_integration_in_trellint?: boolean;
    [key: string]: any;
  };
  timezone: string;
  violation_processor: ViolationProcessor;
}

export interface Authority {
  authority_id: number;
  name: string;
  authority_uuid?: string;
  hidden?: boolean;
  rank?: number;
  config?: AuthorityConfig;
}

export interface AuthorityWithConfig extends Authority {
  authority_uuid: string;
  hidden: boolean;
  rank: number;
  config: AuthorityConfig;
}

export interface AuthorityWizardStep {
  authority: AuthorityWithConfig;
  updateAuthority: (data: Partial<AuthorityWithConfig>) => Promise<Partial<AuthorityWithConfig>>;
  currentStep: number;
}

export interface AuthorityHistory {
  fields_diff: Record<
    string,
    {
      old_value: never;
      new_value: never;
    }
  >;
  created_by: string;
  created_at: string;
  table_name: string;
}

// Backend structure types (stored in DB/JSON)
export interface EventTypeDescriberDetails {
  violation_code: string;
  violation_description: string;
}

// Frontend structure (form/UI representation)
export interface EventTypeDescriber {
  event_type: string;
  violation_code: string;
  violation_description: string;
}

// Imported data structure (everything optional for validation)
export interface ImportedAuthorityData {
  name?: string;
  config?: ImportedAuthorityConfig;
}

interface ImportedEvidencePackagerConfig {
  client_code?: string;
  document_config?: {
    client_name?: string;
    system_short_name?: string;
    system_name?: string | null;
  };
  media_requirements?: unknown | null;
  exclude_trigger_image?: boolean;
  exclude_lp_crop_image?: boolean;
  street_id_source?: string | null;
  address_format?: string;
  data_bar_template?: unknown | null;
  zoom_level?: number | null;
  license_plate_crop_horizontal_adjustment?: number;
  event_type_describers?: Record<string, EventTypeDescriberDetails>;
  [key: string]: unknown;
}

interface ImportedEvidencePackageSchedulerConfig {
  event_lock_grace_period?: string | null;
  configs?: Partial<EvidencePackageSchedulerConfigItem>[] | null;
  [key: string]: unknown;
}

// Separate interface for imported config structure
interface ImportedAuthorityConfig {
  enable_evidence_pipeline?: boolean;
  evidence_package_distributor_config?: Partial<EvidencePackageDistributorConfig>;
  evidence_package_scheduler_config?: ImportedEvidencePackageSchedulerConfig;
  evidence_packager_config?: ImportedEvidencePackagerConfig;
  external_review_enabled?: boolean;
  features_config?: {
    kyndryl_integration_in_trellint?: boolean;
    [key: string]: any;
  };
  timezone?: string;
  violation_processor?: ViolationProcessor;
  [key: string]: unknown;
}
